module.exports = __webpack_public_path__ + "img/photo.47f2c016.png";